import { render } from "./SubscriptionsList.vue?vue&type=template&id=929a7f1a&scoped=true"
import script from "./SubscriptionsList.vue?vue&type=script&lang=js"
export * from "./SubscriptionsList.vue?vue&type=script&lang=js"

import "./SubscriptionsList.vue?vue&type=style&index=0&id=929a7f1a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/leadsbroker-anketa/leadsbroker-anketa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-929a7f1a"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QCardActions});
